// ABOUTME: Toggles the paused state of what moves on its own (the retail logo band, the announcement bar's marquee and rotation) from a button that carries data-jf-pause (WCAG 2.2.2).
// The button's data-jf-pause names, as a selector, the closest ancestor that takes the is-paused class; its stylesheet sets animation-play-state: paused from that class.
// aria-pressed on the button follows the state. A rotating announcement bar has one button, beside its messages, whose is-paused on the bar stops every marquee in it,
// and it stops and starts the bar's rotation too (the bar itself waits while focus is on a message, assets/announcement-bar.js); the messages' live region is quiet
// while they rotate and speaks once they are paused, the WAI carousel pattern. Loading the script twice binds it once.

if (!window.jfPauseToggleBound) {
  window.jfPauseToggleBound = true;

  document.addEventListener('click', (event) => {
    const button = event.target && typeof event.target.closest === 'function' ? event.target.closest('[data-jf-pause]') : null;
    if (!button) return;
    const paused = button.getAttribute('aria-pressed') !== 'true';
    const host = button.closest(button.dataset.jfPause);
    if (host) host.classList.toggle('is-paused', paused);
    button.setAttribute('aria-pressed', String(paused));
    // A bar of one block loads no announcement-bar.js, so it is never defined and has no rotation to stop.
    const bar = button.closest('announcement-bar-component:defined');
    if (!bar) return;
    bar.querySelector('.announcement-bar__slides')?.setAttribute('aria-live', paused ? 'polite' : 'off');
    if (paused) {
      bar.pause();
    } else {
      bar.play();
    }
  });
}
